/**
 * Countdown helper for pending order-change proposals.
 */
export function msUntil(iso: string, nowMs = Date.now()): number {
  return new Date(iso).getTime() - nowMs;
}

export function isExpired(iso: string, nowMs = Date.now()): boolean {
  return msUntil(iso, nowMs) <= 0;
}

/** e.g. "Quedan 4 min" / "Vence ahora" / "Vencida" */
export function formatCountdown(iso: string, nowMs = Date.now()): string {
  const ms = msUntil(iso, nowMs);
  if (ms <= 0) return 'Vencida';
  const min = Math.ceil(ms / 60000);
  if (min <= 1) return 'Vence en menos de 1 min';
  return `Quedan ${min} min`;
}

export function formatExpiresAt(iso: string): string {
  return new Date(iso).toLocaleTimeString('es-AR', { hour: '2-digit', minute: '2-digit' });
}
